"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_HELP = void 0;
exports.CREDIT_BUILDER_HELP = {
    HEADER: 'Want to learn more?',
    CTA: 'Visit our Help Center'
};
